module.exports = __webpack_public_path__ + "static/media/theme-color-diamond.b3c00153.svg";